import { render, staticRenderFns } from "./HistoryBadge.vue?vue&type=template&id=49912547&scoped=true&"
import script from "./HistoryBadge.vue?vue&type=script&lang=js&"
export * from "./HistoryBadge.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBadge.vue?vue&type=style&index=0&id=49912547&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49912547",
  null
  
)

export default component.exports